<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 上级分类">
            <a-select v-model="data.parentId" placeholder="上级分类" v-decorator="[
          'parentId',
          {initialValue:data.parentId,rules: [{ required: false, message: '请选择上级分类' }]}]" :options="this.firstCategory"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类名称">
            <a-input :disabled="params.isShow" v-model="data.name" placeholder="请输入分类名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入分类名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类图片">
            <upload-image @uploadChange="uploadChange" :fileListInit="fileList" :imageCount="1" @cancelFile="cancelFile" :multiple="false"></upload-image>
            <span style="color:red">建议上传图片尺寸为110px*90px</span>
          </a-form-item>
          
        </a-col>
      </a-row>
      <a-row>
        <a-col class="form-row"></a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: "",
  parentId: "0",
  imgUrl: ""
};
export default {
  name: "hp-manager-page-category-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      firstCategory: [
        {
          label: "无",
          value: "0"
        }
      ],
      fileList: [],
      listType: "text",
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    this.getFirstCategory();
    if (this.params.id) {
      this.getdetailCategory();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async uploadImg(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      let data = await api.UploadGoodImg(formData);
      if (data) {
      }
    },
    async getFirstCategory() {
      let categoryList = await api.GetForSelectCategory();
      if (categoryList) {
        categoryList.forEach(a => {
          this.firstCategory.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },
    async getdetailCategory() {
      this.loading = true;
      let result = await api.GetCategory({ productCategoryId: this.params.id });
      if (result) {
        this.data = result;
        this.data.parentId = this.data.parentId + "";
        if (result.imgUrl) {
          this.fileList.push({
            uid: Math.random().toString(),
            name: "1",
            status: "done",
            url: result.imgUrl
          });
          this.$emit("uploadChange", this.fileList);
        }
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        imgUrl: this.fileList.length > 0 ? this.fileList[0].url : "",
        parentId: parseInt(value.parentId)
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        console.log(requestData);
        let data = await api.AddOrUpdateCategory(requestData);
        if (data) {
          if (this.params.id > 0) {
            this.$message.success("修改成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$emit("submit-success");
        }

        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/ProductCategory/Add.vue